
import { Typography, Button } from "../../components"
import "./styles.css";

import offertebrochurePDF from '../../assets/documents/library/offertebrochure2026.pdf';

export default function Offertebrochure(props) {
    return (
        <div className='container'>
            <Typography type='h1' style={{ color: 'var(--trust)', fontSize: '2.2em' }}>Offertebrochure</Typography>
            <div className="button-container">
                <Button 
                    target='_blank' 
                    href={offertebrochurePDF} 
                    text={`Klik hier voor onze offertebrochure`}
                />  
            </div>
        </div>
    )
}
